import { Box, ListItem, ListItemButton } from "@mui/material";
import { Iconify } from "app/components/Iconify";
import { RouterLink } from "app/tools/router/components/RouterLink";
import { usePathname } from "app/tools/router/hooks/usePathname";

import { NavigationItem as NavigationItemEntity } from "../types";

export type NavigationItemProps = {
  navigationItem: NavigationItemEntity;
  onClick?: () => void;
};

export const NavigationItem = ({
  navigationItem,
  onClick,
}: NavigationItemProps) => {
  const pathname = usePathname();
  const isCurrentlySelectedNavigationItem = pathname.startsWith(
    navigationItem.path,
  );

  return (
    <ListItem disableGutters disablePadding key={navigationItem.title}>
      <ListItemButton
        component={RouterLink}
        disableGutters
        href={navigationItem.path}
        onClick={onClick}
        sx={{
          borderRadius: 0.75,
          color: "var(--layout-nav-item-color)",
          fontWeight: "fontWeightMedium",
          gap: 2,
          minHeight: "var(--layout-nav-item-height)",
          pl: 2,
          pr: 1.5,
          py: 1,
          typography: "body2",
          ...(isCurrentlySelectedNavigationItem && {
            "&:hover": {
              bgcolor: "var(--layout-nav-item-hover-bg)",
            },
            bgcolor: "var(--layout-nav-item-active-bg)",
            color: "var(--layout-nav-item-active-color)",
            fontWeight: "fontWeightSemiBold",
          }),
        }}
      >
        <Box component="span" sx={{ height: 24, width: 24 }}>
          <Iconify icon={navigationItem.iconName} width={24} />
        </Box>

        <Box component="span" flexGrow={1}>
          {navigationItem.title}
        </Box>

        {navigationItem.info && navigationItem.info}
      </ListItemButton>
    </ListItem>
  );
};
